import { render, staticRenderFns } from "./jmsSCJYContract.vue?vue&type=template&id=24aac8ec"
import script from "./jmsSCJYContract.vue?vue&type=script&lang=js"
export * from "./jmsSCJYContract.vue?vue&type=script&lang=js"
import style0 from "./jmsSCJYContract.vue?vue&type=style&index=0&id=24aac8ec&prod&lang=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports